import React from 'react';
import { Input } from 'antd';
import FormItem from '../FormItem/FormItem';

const { TextArea } = Input;

const AreaField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
  formItemProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem
      label={label}
      {...formItemProps}
    >
      {getFieldDecorator(name, decoratorOptions)(<TextArea {...fieldProps} />)}
    </FormItem>
  );
};

export default AreaField;
